export const AREA_TYPES = {
    APARTMENT: {
        title: 'area_type_apartment',
        key: 'APARTMENT',
    },
    OFFICE: {
        title: 'area_type_office',
        key: 'OFFICE',
    },
  /*  HOTEL:{
        title: 'area_type_hotel',
        key: 'HOTEL',
    },*/
    PARKING:{
        title: 'area_type_perking',
        key: 'PARKING',
    },
};

export const CURRENCY_VALUE = ['USD_AMD', 'EUR_AMD', 'RUB_AMD']

export const CURRENCY_ENUM = {
    AMD : 'AMD',
    USD : 'USD',
    RUB : 'RUB',
}

export const CURRENCIES= {
    AMD: {
        key: CURRENCY_ENUM.AMD,
        suffix: '֏',
    },
    USD: {
        key: CURRENCY_ENUM.USD,
        suffix: '$',
    },
    RUB: {
        key: CURRENCY_ENUM.RUB,
        suffix: '₽',
    },
};